import { SortableContext } from "@dnd-kit/sortable";

import type { SnackBlocksFormModelContentsMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods/contents";

import { LayoutSettingsIslandContentRow } from "./item";

type Props = {
	hotelID: string;
	contentsMethods: SnackBlocksFormModelContentsMethodsType;
};

export const LayoutSettingsIslandContentRows = ({ hotelID, contentsMethods }: Props) => {
	return (
		<SortableContext
			items={contentsMethods.blocks.value.map((item) => {
				return { id: item.uuid.value };
			})}
		>
			<div className="w-[90%] space-y-12">
				{contentsMethods.blocks.value.map((block, index) => {
					return (
						<LayoutSettingsIslandContentRow
							key={block.uuid.value}
							hotelID={hotelID}
							index={index}
							block={block}
							contentsMethods={contentsMethods}
						/>
					);
				})}
			</div>
		</SortableContext>
	);
};

LayoutSettingsIslandContentRows.displayName = "LayoutSettingsIslandContentRows";
